export const INSUFF_DATA_LOADING = "INSUFF_DATA_LOADING";
export const INSUFF_DATA_SUCCESS = "INSUFF_DATA_SUCCESS";
export const INSUFF_DATA_FAILED = "INSUFF_DATA_FAILED";

export const INSUFF_DATA_SAVE_LOADING = "INSUFF_DATA_SAVE_LOADING";
export const INSUFF_DATA_SAVE_SUCCESS = "INSUFF_DATA_SAVE_SUCCESS";
export const INSUFF_DATA_SAVE_FAILED = "INSUFF_DATA_SAVE_FAILED";

export const INSUFF_UPLOAD_FILE_MULTIPART_LOADING = "INSUFF_UPLOAD_FILE_MULTIPART_LOADING";
export const INSUFF_UPLOAD_FILE_MULTIPART_SUCCESS = "INSUFF_UPLOAD_FILE_MULTIPART_SUCCESS";
export const INSUFF_UPLOAD_FILE_MULTIPART_FAILED = "INSUFF_UPLOAD_FILE_MULTIPART_FAILED";

export const INSUFF_DELETE_FILES_LOADING = "INSUFF_DELETE_FILES_LOADING";
export const INSUFF_DELETE_FILES_SUCCESS = "INSUFF_DELETE_FILES_SUCCESS";
export const INSUFF_DELETE_FILES_FAILED = "INSUFF_DELETE_FILES_FAILED";

export const REMOVE_SINGLE_FILE_LOADING = "REMOVE_SINGLE_FILE_LOADING";
export const REMOVE_SINGLE_FILE_SUCCESS = "REMOVE_SINGLE_FILE_SUCCESS";
export const REMOVE_SINGLE_FILE_FAILED = "REMOVE_SINGLE_FILE_FAILED";
